import '../../scss/Components/infinite-scroll.scss';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
var InfiniteScroll = function (_a) {
    var callback = _a.callback, loading = _a.loading, _b = _a.options, options = _b === void 0 ? {} : _b, seeMoreCount = _a.seeMoreCount, _c = _a.useIntersection, useIntersection = _c === void 0 ? true : _c;
    var _d = React.useState(false), isClicked = _d[0], setIsClicked = _d[1];
    var _e = useInView(options), ref = _e.ref, inView = _e.inView;
    var content = React.createElement(React.Fragment, null,
        React.createElement("div", { className: "infinite-scroll-loader" },
            React.createElement("svg", { className: "spinner", viewBox: "0 0 50 50" },
                React.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }))),
        React.createElement("div", { className: "see-more" },
            React.createElement("p", null,
                "See ",
                seeMoreCount,
                " more"),
            React.createElement("i", { className: "fas fa-angle-double-down" })));
    React.useEffect(function () {
        if ((inView || isClicked) && !loading) {
            callback();
        }
        return function () { return setIsClicked(false); };
    }, [inView, isClicked]);
    if (useIntersection) {
        return (React.createElement("div", { className: "infinite-scroll " + (loading ? 'loading' : ''), ref: ref }, content));
    }
    return (React.createElement("div", { className: "infinite-scroll " + (loading ? 'loading' : ''), onClick: function () { return setIsClicked(true); } }, content));
};
export default InfiniteScroll;
